module.exports = __WEBPACK_EXTERNAL_MODULE_tabulator_tables__;